if (!customElements.get('lead-time-acknowledgement')) {
  customElements.define(
    'lead-time-acknowledgement',
    class LeadTimeAcknowledgement extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.checkbox = this.querySelector('[data-lead-time-acknowledgement]');
        this.form = this.closest('form');
        this.submitButton = this.form?.querySelector('[name="add"]');

        if (!this.checkbox || !this.form || !this.submitButton) return;

        this.dataset.initialized = 'true';
        this.checkbox.addEventListener('change', () => this.syncButton());
        this.form.addEventListener('submit', (event) => this.requireAcknowledgement(event), true);
        this.syncButton();
      }

      syncButton() {
        const variantDisabled = this.submitButton.dataset.variantDisabled === 'true';
        this.submitButton.toggleAttribute('disabled', variantDisabled || !this.checkbox.checked);
      }

      requireAcknowledgement(event) {
        if (this.checkbox.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.checkbox.focus();
        this.syncButton();
      }
    }
  );
}
